import { Component } from '@theme/component';
import { ChapterPanel } from '@theme/chapter-panel';

/**
 * <product-subnav-bar> — the sticky product sub-navigation on product
 * landing pages. chrome.js treats it as the takeover target: while the site
 * header is up the bar stays hidden beneath it, and once the header retracts
 * on scroll the bar is revealed pinned at the top of the viewport.
 *
 * Mobile interaction: the bar's chapter picker (chevron-down next to the
 * Buy pill) unfolds the shared ChapterPanel below the bar. Selecting a chapter
 * closes the panel and lets the anchor default (hash navigation) scroll the
 * chapter into view.
 */
class ProductSubnavBar extends Component {
  #chapters = null;

  connectedCallback() {
    super.connectedCallback();

    this.#chapters = new ChapterPanel(this, {
      panel: '[data-chapters-panel]',
      toggle: '.product-subnav__chapters-toggle',
      stage: '.product-subnav__chapters-stage',
      curtain: '[data-chapters-curtain]',
    });
    this.#chapters.connect();
  }

  disconnectedCallback() {
    this.#chapters?.disconnect();
    this.#chapters = null;
    super.disconnectedCallback();
  }

  /** Delegated from the chevron button (on:click). */
  toggleChapters() {
    this.#chapters?.toggle();
  }

  /** Delegated from the chapter links: close and let the anchor default
      (hash navigation) scroll the chapter into view. */
  selectChapter() {
    this.#chapters?.close();
  }
}

if (!customElements.get('product-subnav-bar')) {
  customElements.define('product-subnav-bar', ProductSubnavBar);
}
